import { render, staticRenderFns } from "./MtdTransactionDate.vue?vue&type=template&id=2d03bbfd&scoped=true&"
import script from "./MtdTransactionDate.vue?vue&type=script&lang=js&"
export * from "./MtdTransactionDate.vue?vue&type=script&lang=js&"
import style0 from "./MtdTransactionDate.vue?vue&type=style&index=0&id=2d03bbfd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d03bbfd",
  null
  
)

export default component.exports